import React from 'react';
import { Archive } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';

/**
 * The band across the top of an archived resource's editor.
 *
 * Archiving happens from a `⋯` menu and used to leave a page that looked exactly
 * as it did before, so the only feedback was a toast that scrolled away. This is
 * the standing version of that fact.
 *
 * Shared because the wording is the only part that differs per resource — what
 * archiving actually costs is different for a chat than for a workflow — while
 * the band itself has to look identical, or the same state reads as two
 * different severities depending on which editor you are in.
 *
 * Amber, not destructive red: nothing here is broken or lost. `border-b` rather
 * than a rounded card, because this belongs to the page's chrome and sits
 * directly under the bar.
 */
export const ArchivedNotice: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="flex shrink-0 items-start gap-2 border-b border-amber-500/20 bg-amber-500/5 px-4 py-2">
    <Archive
      className="mt-0.5 h-4 w-4 shrink-0 text-amber-600"
      aria-hidden="true"
    />
    <Text.Caption className="text-amber-700">{children}</Text.Caption>
  </div>
);
